export default __webpack_public_path__ + "assets/images/d486dc25482253b60fdba3fb571ee115.png";